import React from 'react'
import { Fade } from "react-awesome-reveal";
import backbtn from '../../../assets/back-button.png'

function Police({setKey}) {
  return (
    <Fade>
    <div style={{width: "100%", display: "flex", justifyContent: "center", padding: "2rem"}}>ЦАГДААГИЙН ЕРӨНХИЙ ГАЗАР</div>
    <div className='back-button' onClick={()=>setKey("2")}>
        <img  src={backbtn} alt="back button"  style={{ width: "18px", height: "18px", objectFit: "cover"}} />
    </div>
    </Fade>
  )
}

export default Police